import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogContent, MatDialogTitle, MatDialogActions } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { AdminTaskFileDialog } from 'src/app/admin/components/admin-task-file-dialog/admin-task-file-dialog.component';
import { AdminTaskListService } from 'src/app/admin/services/admin-task-list.service';
import { TaskType } from '../../services/tasklist.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgIf, NgFor } from '@angular/common';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-task-file-dialog',
    templateUrl: './task-file-dialog.component.html',
    styleUrls: ['./task-file-dialog.component.scss'],
    imports: [CdkScrollable, MatDialogContent, MatDialogTitle, NgIf, NgFor, MatDialogActions, MatButton]
})
export class TaskFileDialog implements OnInit {

  task:TaskType;

  largeImage:string;

  fileListSub$: Subscription;
  fileList: any[];

  displayedColumns: string[] = [ 'image' ];

  constructor(
    public dialogRef: MatDialogRef<AdminTaskFileDialog>,
    @Inject(MAT_DIALOG_DATA) public inData: TaskFileDialogData,
    private svcAdminTaskList:AdminTaskListService,
  ) { 
    this.task = inData.task;
  }

  ngOnInit(): void {
    this.loadFileList();
  }

  loadFileList(): void {
    if (this.fileListSub$) this.fileListSub$.unsubscribe();

    this.fileListSub$ = this.svcAdminTaskList.taskFileList(this.task.configid).subscribe(
      (out) => {
        this.fileList = out.Body;
      }
    )
  }

  zoomImage(s3link:string):void {
    this.largeImage = s3link;
  }

  close():void {
    this.dialogRef.close();
  }

}

export interface TaskFileDialogData {
  task: TaskType
  site: string;
  environment: string;
  object: string;
}